import { createRouter, createWebHistory } from 'vue-router';
import type { RouteRecordRaw } from 'vue-router';
import { systemRoutes } from './modules/system';
import { academicsRoutes } from './modules/academics';
import { attendanceRoutes } from './modules/attendance';
import { gradesRoutes } from './modules/grades';
import { schoolsRoutes } from './modules/schools';
import { reportsRoutes } from './modules/reports';
import { timetableRoutes } from './modules/timetable';

const requireAuth = (_to: any, _from: any, next: any) => {
    localStorage.getItem('authenticated') === 'yes' ? next() : next({ name: 'SignIn' });
};

const requireNoAuth = (_to: any, _from: any, next: any) => {
    localStorage.getItem('authenticated') === 'yes' ? next({ name: 'schools' }) : next();
};
new Set([
    'createGenderTypes', 'createBoardingStatus', 'createSchoolGenderStatus',
    'createSchoolTypes', 'createRelationships', 'createDegreeLevels',
    'createDegreeInstitutions', 'createDegreeField', 'createStaffStatues',
    'createStudentStatues', 'createCurriculum', 'createAcademicYears',
    'createTerms', 'createSubjects', 'createLevelPrefix', 'createLevel'
])
export const routes: Array<RouteRecordRaw> = [
    {
        path: '/auth',
        component: () => import('@/layouts/auth/AuthLayout.vue'),
        children: [
            {
                path: '',
                name: 'SignIn',
                component: () => import('@/views/auth/SignInView.vue'),
                beforeEnter: requireNoAuth,
            }
        ],
    },
    {
        path: '/',
        component: () => import('@/layouts/shared/ProjectLayout.vue'),
        beforeEnter: requireAuth,
        children: [
            {
                path: '',
                redirect: { name: 'schools' }
            },
            systemRoutes,
            academicsRoutes,
            attendanceRoutes,
            gradesRoutes,
            schoolsRoutes,
            reportsRoutes,
            timetableRoutes,
        ]
    },
    {
        path: '/server-not-available',
        name: 'ServerNotAvailable',
        component: () => import('@/views/ServerNotAvailableView.vue'),
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: () => import('@/views/NotFoundView.vue'),
    }
];

export const router = createRouter({
    history: createWebHistory(),
    routes,
});